export class ActiveIncentivesAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The market's offers with their state and spend, and the governed state of the lever policy and the fund (`incentive_lever:view`). */
    list(marketId, lever) {
        const query = new URLSearchParams({ market: marketId, ...(lever !== undefined ? { lever } : {}) });
        return this.client.request({ method: 'GET', path: `/v1/admin/active-incentives?${query.toString()}`, auth: true });
    }
    /** The append-only trail of one offer (`incentive_lever:view`). */
    events(marketId, incentiveId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/active-incentives/${encodeURIComponent(incentiveId)}/events?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /** D492: the settlements of one guarantee (paid, unpaid by cap, not eligible) and its reservation (`incentive_lever:view`). */
    settlements(marketId, incentiveId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/active-incentives/${encodeURIComponent(incentiveId)}/settlements?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /** D494: the orders one delivery-fee subsidy was promised to, and what became of each (`incentive_lever:view`). */
    subsidies(marketId, incentiveId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/active-incentives/${encodeURIComponent(incentiveId)}/subsidies?${new URLSearchParams({ market: marketId }).toString()}`, auth: true });
    }
    /** PROPOSE a time-boxed offer (the maker, `incentive_lever:manage`); `409 INCENTIVE_LEVER_POLICY_UNSET` / `INCENTIVE_FUND_POLICY_UNSET` without the policies. */
    propose(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/active-incentives', body: input, auth: true });
    }
    /** The checker (never the proposer, `incentive_lever:approve`) approves or refuses; `403 INCENTIVE_SELF_APPROVAL` for the proposer. */
    decide(incentiveId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/active-incentives/${encodeURIComponent(incentiveId)}/decision`, body: input, auth: true });
    }
    /** END an approved offer early (a kill, `incentive_lever:manage`): one operator is enough. */
    end(incentiveId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/active-incentives/${encodeURIComponent(incentiveId)}/end`, body: input, auth: true });
    }
}
//# sourceMappingURL=active-incentives.js.map